import { render, staticRenderFns } from "./PpmQuestionnaire.vue?vue&type=template&id=2d272ced&scoped=true"
import script from "./PpmQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./PpmQuestionnaire.vue?vue&type=script&lang=ts"
import style0 from "./PpmQuestionnaire.vue?vue&type=style&index=0&id=2d272ced&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d272ced",
  null
  
)

export default component.exports